module.exports = __webpack_public_path__ + "static/tercerafecha-4d8dd040f241cea0dea65747982e7137.jpg";